// Create a new file for your custom hook, e.g., useMediaQuery.js
import { useEffect, useState } from "react";

export function useMediaQuery(query) {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia(query);

    // Function to update the matches state
    const updateMatches = () => {
      setMatches(mediaQuery.matches);
    };

    // Initial check
    updateMatches();

    // Add a listener for changes in viewport size
    mediaQuery.addListener(updateMatches);

    // Clean up the listener when the component unmounts
    return () => {
      mediaQuery.removeListener(updateMatches);
    };
  }, [query]);

  return matches;
}
